import React from "react";
import { Route, Routes } from "react-router-dom";
import MainColophonPage from "./MainColophonPage";
import ProtectedRoute from "../../ProtectedRoute";
import AddEditColophonPage from "./AddEditColophonPage";
import ViewColophonPage from "./ViewColophonPage";
import PageNotFound from "../PageNotFound";

const ColophonRouter: React.FC = () => {
  return (
    <Routes>
      <Route
        index
        element={<ProtectedRoute element={<MainColophonPage />} />}
      />
      <Route
        path="create"
        element={<ProtectedRoute element={<AddEditColophonPage />} />}
      />
      <Route
        path=":_id/edit"
        element={<ProtectedRoute element={<AddEditColophonPage />} />}
      />
      <Route
        path=":_id"
        element={<ProtectedRoute element={<ViewColophonPage />} />}
      />
      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
};

export default ColophonRouter;
